import FlagGenerator from './Components/FlagGenerator';

export default FlagGenerator('randomized');
